import { Type } from "@sinclair/typebox";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../lib/api.js";
export const joinByCodeResponseSchema = Type.Object({
    team_id: Type.String(),
});
// Create the API function.
export const joinByCode = async (joinTeamByCodeRequest) => {
    return api
        .post("teams/joinByCode", {
        json: joinTeamByCodeRequest,
    })
        .json();
};
// Create the custom hook.
export const useJoinByCode = ({ mutationConfig }) => {
    const queryClient = useQueryClient();
    const { onSuccess, ...restConfig } = mutationConfig || {};
    return useMutation({
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["join-team-by-code"],
            });
            onSuccess?.(...args);
        },
        onError: (error) => {
            console.log("Error in useJoinByCode:", error);
            // Extract the error message from the API error response
            const message = error?.message || "An unexpected error occurred";
            throw new Error(message);
        },
        ...restConfig,
        mutationFn: joinByCode,
    });
};
//# sourceMappingURL=joinTeamByCode.js.map